import { useCallback, useState, ReactNode, FC } from "react";
import cn from "classnames";
import ShowMoreContext from "./show-more-context";
import ShowMoreContextComponent, {
  ShowMoreContextComponentProps,
} from "./show-more-context/show-more-context-component";
import ShowMoreButton, { ShowMoreButtonProps } from "./show-more-button";
import ShowMoreItems, { ShowMoreItemsProps } from "./show-more-items";

export interface ShowMoreProps {
  limit?: number;
  children: ReactNode;
  className?: string;
}
export interface ShowMoreComposite extends ShowMoreProps {
  Context?: FC<ShowMoreContextComponentProps>;
  Button?: FC<ShowMoreButtonProps>;
  Items?: FC<ShowMoreItemsProps>;
}

const ShowMore = ({ limit = 10, children, className }: ShowMoreComposite) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const setItems = useCallback(
    (newState: number) => {
      setTotalItems(newState);
    },
    [setTotalItems],
  );

  return (
    <ShowMoreContext.Provider
      value={{
        limit,
        isExpanded,
        toggleIsExpanded: () => setIsExpanded(!isExpanded),
        totalItems,
        setTotalItems: setItems,
      }}
    >
      <div className={cn("eb-show-more", className)} data-auto="show-more">
        {children}
      </div>
    </ShowMoreContext.Provider>
  );
};

ShowMore.Context = ShowMoreContextComponent;
ShowMore.Button = ShowMoreButton;
ShowMore.Items = ShowMoreItems;

export default ShowMore;
